var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMentalHealth = function SvgIconMentalHealth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    d: "M19 23.01v-6.3a9 9 0 1 0-15-6.7v1l-2 4 2 1v3a2 2 0 0 0 2 2h4v2"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.667,
    d: "M18 8.333h-3.333V5h-3.334v3.333H8v3.334h3.333V15h3.334v-3.333H18z"
  })))));
};
export { SvgIconMentalHealth as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPgogICAgICAgIDxnIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xOSAyMy4wMXYtNi4zYTkgOSAwIDEgMC0xNS02Ljd2MWwtMiA0IDIgMXYzYTIgMiAwIDAgMCAyIDJoNHYyIiBzdHJva2Utd2lkdGg9IjIiLz4KICAgICAgICAgICAgPHBhdGggc3Ryb2tlLXdpZHRoPSIxLjY2NyIgZD0iTTE4IDguMzMzaC0zLjMzM1Y1aC0zLjMzNHYzLjMzM0g4djMuMzM0aDMuMzMzVjE1aDMuMzM0di0zLjMzM0gxOHoiLz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";